import React, { Component } from "react";

type FormFieldType = {
    name: string;
    label: string;
    type: "email" | "text" | "textarea";
    required: boolean;
};

type FormType = {
    id: string;
    url: string;
    fields: Array<FormFieldType>;
    errors?: Array<any>;
    csrfName: string;
    csrfToken: string;
};

type PropsType = {
    form: FormType;
};

const withForm = (WrappedComponent: Component) => props => {
    let { form, ...restProps } = props;

    return <WrappedComponent form={form} {...restProps} />;
};

export default withForm;
export { PropsType, FormType, FormFieldType };
